import ClientDetailContainer from "@/features/clients/containers/client-detail-container";
import { createFileRoute } from "@tanstack/react-router";

// Index child of $clientId layout: renders the client detail view
export const Route = createFileRoute("/app/clients/$clientId/")({
  component: ClientDetailContainer,
});
